<template>
  <div class="row">
    <div class="col-lg-12">
      <button
        type="button"
        class="btn btn-primary btn-voltar"
        @click="$router.back()"
      >
        <font-awesome-icon :icon="'arrow-left'" />
        Voltar
      </button>
      <h1 class="page-header margem-titulo">Adicionar Usuário</h1>
      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <form role="form" @submit.prevent="save()" id="user_form">
            <fieldset>
              <!-- Text input-->
              <div class="row">
                <div class="form-group col-md-3 pad-right-0">
                  <label
                    for="usuario"
                    :class="[
                      'custom-font',
                      { 'is-danger': errors.has('usuario') }
                    ]"
                    >Usuário</label
                  >
                  <div class="input-group">
                    <input
                      ref="usuario"
                      name="usuario"
                      v-model="model.username"
                      v-validate="'required'"
                      :class="[
                        'form-control',
                        { 'is-danger': errors.has('usuario') }
                      ]"
                      placeholder="Usuário"
                      type="text"
                    />
                    <span
                      class="custom-font input-group-addon remove-background-color-border"
                      style="background-color:transparent;border-width:0px"
                      >Ou</span
                    >
                  </div>
                  <span v-show="errors.has('usuario')" class="is-danger">
                    <font-awesome-icon
                      :icon="'exclamation-triangle'"
                    ></font-awesome-icon>
                    {{ errors.first('usuario') }}
                  </span>
                </div>
                <div class="form-group col-md-3 pad-left-0">
                  <label for="usuario" class="custom-font">SSHD</label>
                  <div class="input-group">
                    <input
                      type="text"
                      v-model="SSHD"
                      class="form-control"
                      @keypress.enter="getUserBySSHD"
                    />
                    <span class="input-group-btn">
                      <button
                        title="Pesquisar o SSHD"
                        class="btn btn-default"
                        @click="getUserBySSHD"
                        type="button"
                      >
                        <font-awesome-icon :icon="'search'"></font-awesome-icon>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div :class="['form-group col-md-6']">
                  <label
                    for="nome"
                    :class="[
                      'custom-font',
                      { 'is-danger': errors.has('nome') }
                    ]"
                    >Nome do usuário</label
                  >
                  <input
                    ref="nome"
                    v-model="model.USU_NMUSUARIO"
                    v-validate="'required'"
                    :class="[
                      'form-control',
                      { 'is-danger': errors.has('nome') }
                    ]"
                    name="nome"
                    placeholder="Nome do usuário"
                    type="text"
                  />
                  <span v-show="errors.has('nome')" class="is-danger">
                    <font-awesome-icon
                      :icon="'exclamation-triangle'"
                    ></font-awesome-icon>
                    {{ errors.first('nome') }}
                  </span>
                </div>
              </div>
              <div class="row">
                <div :class="['form-group col-md-6']">
                  <label
                    for="email"
                    :class="[
                      'custom-font',
                      { 'is-danger': errors.has('email') }
                    ]"
                    >Email</label
                  >
                  <input
                    ref="email"
                    v-model="model.USU_DCEMAIL"
                    v-validate="'email'"
                    :class="[
                      'form-control',
                      { 'is-danger': errors.has('email') }
                    ]"
                    name="email"
                    placeholder="email@santos.sp.gov.br"
                    type="text"
                  />
                  <span v-show="errors.has('email')" class="is-danger">
                    <font-awesome-icon
                      :icon="'exclamation-triangle'"
                    ></font-awesome-icon>
                    {{ errors.first('email') }}
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="origem" class="custom-font"
                    >Origem (Somente para usuário externo)</label
                  >
                  <input
                    ref="origem"
                    v-model="model.USU_DCORIGEM"
                    class="form-control"
                    name="origem"
                    placeholder="Origem Ex: nome da organização"
                    type="text"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <b>Perfil</b>
                    </div>
                    <div class="panel-body">
                      <div
                        v-for="perfil in listaPerfil"
                        :key="perfil.PER_IDPERFIL"
                        class="form-group col-md-12"
                      >
                        <label>
                          <div>
                            <input
                              type="checkbox"
                              name="perfil"
                              :value="perfil.PER_IDPERFIL"
                              v-model="checkedProfiles"
                              :checked="perfil.checked"
                              @input="
                                event => (perfil.checked = event.target.checked)
                              "
                            />
                            <span>{{ perfil.PER_DCPERFIL }}</span>
                          </div>
                        </label>
                        <div
                          v-if="perfil.PER_CDPERFIL.trim().toLowerCase() === 'temporario'"
                        >
                          <div
                            :class="[
                              { 'has-error': errors.has('data_expiracao') }
                            ]"
                          >
                            <div class="inputgroupcontainer">
                              <div class="input-group">
                                <span class="input-group-addon">
                                  <font-awesome-icon
                                    :icon="'calendar'"
                                    :class="[
                                      {
                                        'is-danger': errors.has(
                                          'data_expiracao_campo'
                                        )
                                      }
                                    ]"
                                  />
                                </span>
                                <the-mask
                                  ref="data_expiracao_campo"
                                  v-model="data_expiracao_campo"
                                  name="data_expiracao_campo"
                                  placeholder="Data de expiração"
                                  class="form-control"
                                  v-validate.immediate="
                                    'required_if:temporaryIsChecked'
                                  "
                                  maxlength="20"
                                  :mask="'##/##/####, ##:##:##'"
                                  type="text"
                                  :disabled="!checkedProfiles.includes(13)"
                                />
                                <div
                                  :class="[
                                    'input-group-addon custom-input-group-addon-count',
                                    {
                                      'is-danger': errors.has(
                                        'data_expiracao_campo'
                                      )
                                    }
                                  ]"
                                  v-text="14 - data_expiracao_campo.length"
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Button -->
              <div class="form-group">
                <div class="">
                  <button class="btn btn-default" :disabled="carregando">
                    <font-awesome-icon
                      v-if="carregando"
                      :icon="'spinner'"
                      spin
                    />
                    <font-awesome-icon v-else :icon="'save'" />
                    Salvar
                  </button>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '@/request'
import { TheMask } from 'vue-the-mask'
import { ref } from 'vue'

export default {
  components: {
    TheMask
  },
  name: 'user-save',
  data() {
    return {
      isUpdate: false,
      listaPerfil: [],
      SSHD: '',
      carregando: false,
      data_expiracao: '',
      data_expiracao_campo: '',
      responsavel_username: '',
      model: {
        username: '',
        USU_NMUSUARIO: '',
        USU_DCEMAIL: '',
        USU_DCORIGEM: ''
      }
    }
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  created() {
    this.loadPerfis()
  },
  setup() {
    const checkedProfiles = ref([])

    return {
      checkedProfiles
    }
  },
  mounted() {
    this.$refs.usuario.focus()
    this.responsavel_username = this.$store.state.user.username
  },
  computed: {
    perfisChecked() {
      return this.listaPerfil
        .filter(perfil => perfil.checked)
        .map(({ PER_IDPERFIL, PER_CDPERFIL }) => {
          const data_expiracao =
            PER_CDPERFIL === 'temporario' ? this.data_expiracao : null

          return {
            PER_IDPERFIL,
            data_expiracao,
            reponsaveL_username: this.responsavel_username
          }
        })
    }
  },
  methods: {
    formatarDataExpiracao() {
      const day = this.data_expiracao_campo.slice(0, 2)
      const month = this.data_expiracao_campo.slice(2, 4)
      const year = this.data_expiracao_campo.slice(4, 8)

      const hours = this.data_expiracao_campo.slice(8, 10)
      const minutes = this.data_expiracao_campo.slice(10, 12)
      const seconds = this.data_expiracao_campo.slice(12, 14)

      if (this.data_expiracao_campo !== '') {
        this.data_expiracao =
          year +
          '-' +
          month +
          '-' +
          day +
          ' ' +
          hours +
          ':' +
          minutes +
          ':' +
          seconds
      }
    },
    getUserBySSHD() {
      this.toogleLoading()

      request
        .post(`user/getsshd`, { sshd: this.SSHD })
        .then(response => {
          const { data } = response

          if (data.status == false) {
            this.$toastr.e(data.msg)
            return
          }

          this.model.username = data.data.iun
          this.model.USU_NMUSUARIO = data.data.nome
          this.model.USU_DCEMAIL = data.data.email_corporativo

          if (this.USU_DCEMAIL) this.$refs.email.focus()

          this.toogleLoading()
        })
        .catch(e => {
          console.log(e)
          this.$toastr.e(
            'Houve um erro ao tentar realizar a pesquisa, tente novamente em alguns minutos!'
          )
          this.toogleLoading()
        })
    },
    loadPerfis() {
      request.get('user/perfis').then(response => {
        let fetchedPerfis = response.data.map(item => ({
          ...item,
          checked: false
        }));

        const desiredOrder = [
          'admin', 'default', 
          'gestor', 'operador',
          'pdg-master', 'pdg-gestor', 'pdg-user',
          'sms-admin', 'sms-gest', 'sms-user', 
          'mp-user', 'assistencia', 
          'concursos-admin', 'concursos-default', 
          'emendas-default', 'eleicao-conselho', 'temporario', 
        ];

        this.listaPerfil = fetchedPerfis.sort((a, b) => {
          const nameA = a.PER_CDPERFIL.toLowerCase();
          const nameB = b.PER_CDPERFIL.toLowerCase();

          const indexA = desiredOrder.indexOf(nameA);
          const indexB = desiredOrder.indexOf(nameB);

          if (indexA !== -1 && indexB !== -1) {
            return indexA - indexB;
          }

          if (indexA !== -1) {
            return -1;
          }

          if (indexB !== -1) {
            return 1;
          }

          return nameA.localeCompare(nameB);
        });

        this.checkIsUpdateAndSetUserDataByRouteParams();
      });
    },
    checkIsUpdateAndSetUserDataByRouteParams() {
      const { params } = this.$router.history.current
      if (params.hasOwnProperty('data')) {
        this.isUpdate = true
        this.model = params.data

        const perfisId = params.data.perfis.map(
          ({ PER_IDPERFIL }) => PER_IDPERFIL
        )
        this.checkedProfiles = perfisId

        perfisId.forEach(id => {
          const index = this.listaPerfil.findIndex(
            item => item.PER_IDPERFIL === id
          )
          if (index > -1) {
            this.listaPerfil[index].checked = true
          }
        })
      }
    },
    save() {
      this.formatarDataExpiracao()
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$refs[this.$validator.errors.items[0].field].focus()
          this.$toastr.e(this.$validator.errors.items[0].msg)
          return
        }

        const payload = {
          ...this.model,
          perfis: this.perfisChecked
        }

        request
          .post(`user/save`, payload)
          .then(this.saveSuccess)
          .catch(this.saveFail)
      })
    },
    saveSuccess(result) {
      this.$toastr.s('Usuário salvo com sucesso.')
      this.$router.push('/admin/users/list')
    },
    saveFail(result) {
      this.$toastr.e(result)
    },
    toogleLoading() {
      this.carregando = !this.carregando
    }
  }
}
</script>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}

.custom-font.is-danger {
  color: #990000;
}

.btn-voltar {
  margin-top: 20px;
}

.campo-expiracao {
  flex: auto;
}

@media (min-width: 280px) {
  .label-expiracao {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
}

@media (min-width: 545px) {
  .label-expiracao {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}

@media (min-width: 768px) {
  .label-expiracao {
    display: flex;
    flex-direction: column;
    align-items: start;
  }
}

@media (min-width: 1370px) {
  .label-expiracao {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/admin/users/Save.vue